import React from 'react';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { styles } from './MainLogoPressable.styles';
import Button from '../buttons/button/Button';
import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { MainLogoPressableProps } from './MainLogoPressable.types';

export const MainLogoPressable = observer(
  ({
    testID = TestIDs.PHOTOSI_LOGO,
    focusId,
    focusOrder = 0,
    focusGroup = FocusGroups.HEADER,
    accessibilityRole = 'button',
    accessibilityLabel,
    accessible = true,
  }: MainLogoPressableProps) => {
    const {
      user: { isRetailer },
      dynamicModal: { openModal },
    } = useStore();

    const iconName = isRetailer ? ICON_NAMES.PhotosiB2bLogo : ICON_NAMES.PhotosiLogo;

    return (
      <Button
        testID={testID}
        accessible={accessible}
        accessibilityLabel={accessibilityLabel ?? iconName}
        accessibilityRole={accessibilityRole}
        focusId={focusId ?? testID}
        focusOrder={focusOrder}
        focusGroup={focusGroup}
        style={styles.button}
        onPress={async () => {
          openModal({ dynamicModalView: DYNAMIC_MODAL_VIEWS.ExitProject });
        }}
      >
        {() => <Icon testID={`${testID}-icon`} name={iconName} />}
      </Button>
    );
  },
);
